<template>
    <div>
        <el-page-header @back="close" :content="form.id > 0 ? '编辑彩信工单' : '新增彩信工单'"></el-page-header>
        <el-row>
            <el-col :span="18" :offset="3">
                <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="100px">
                    <el-form-item label="业务" prop="code" :error="errors.code">
                        <Cascade ref="cascade" v-model="form.code" @change="changeCode"></Cascade>
                    </el-form-item>
                    <el-form-item label="工单名称" prop="name" :error="errors.name">
                        <el-input v-model="form.name" maxlength="50" show-word-limit style="width: 400px"></el-input>
                    </el-form-item>
                    <el-form-item label="彩信模板" prop="template">
                        <RemoteSelect v-model="group" :options="groups" value-name="id" label-name="name" @change="changeGroup"></RemoteSelect>
                        <RemoteSelect v-model="form.template" :options="templates"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="名单类型" prop="rosterType" v-if="form.type">
                        <el-select v-model="form.rosterType" placeholder="请选择">
                            <el-option label="文件" value="file"></el-option>
                            <el-option label="名单批次" value="namelist" v-if="form.type  === 'mms_normal'"></el-option>
                            <el-option label="手工录入" value="textarea" v-if="form.type  === 'mms_normal'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择文件" v-if="form.rosterType === 'file'">
                        <el-upload ref="upload" :action="$utils.getApiPath('/job/save')" :auto-upload="false"
                                   :data="form"
                                   :headers="headers" :file-list="fileList" :accept="accept" :limit="1"
                                   :on-success="onSuccess" :before-upload="beforeUpload">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <div class="help-text" v-if="form.type === 'mms_normal'">
                            支持txt、csv和xlsx文件；短信内容通过页面配置，所有手机收到的短信都相同，上传文件只需包含手机号。<br>
                            <strong>Excel：</strong>第一行为标题行，第一列为手机号。<br>
                            <strong>Csv：</strong>每一行一个手机号（不需要标题行）<br>
                            <strong>Txt：</strong>每一行一个手机号<br>
                        </div>
                        <div class="help-text" v-if="form.type === 'mms_template'">
                            <strong>支持xlsx文件</strong><br>
                            文件第一行为标题，第一列为手机号，其余列为模板中配置的参数名，列名与参数名需一一对应。
                        </div>
                    </el-form-item>
                    <el-form-item label="手机号" v-if="form.rosterType === 'textarea'" prop="rosterContent">
                        <el-input type="textarea" :rows="3" v-model="form.rosterContent" maxlength="1500" show-word-limit></el-input>
                        <p class="help-text">注意事项：<br>1、手机号之间用英文逗号分隔</p>
                    </el-form-item>
                    <el-form-item label="批次名单" v-if="form.rosterType === 'namelist'" prop="rosterContent">
                        <RemoteSelect v-model="form.rosterContent" url="/namelist/list" label-name="name" value-name="id"></RemoteSelect>
                    </el-form-item>
                    <el-form-item label="手机号去重">
                        <el-radio v-model="form.doUnique" :label="true">是</el-radio>
                        <el-radio v-model="form.doUnique" :label="false">否</el-radio>
                    </el-form-item>
                    <el-form-item label="执行时间" prop="planTime" :error="errors.planTime">
                        <el-date-picker v-model="form.planTime" type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions1" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Cascade from '@/components/Cascade'
    import RemoteSelect from '@/components/RemoteSelect'

    export default {
        components: {
            Cascade,
            RemoteSelect
        },
        data() {
            return {
                form: {
                    id: this.$route.params.id,
                    name: "",
                    type: "",
                    template: "",
                    rosterType: "",
                    rosterContent: "",
                    doUnique: true,
                    planTime: "",
                    code: ""
                },
                rules: {
                    name: [
                        {required: true, message: "请填写工单名称"}
                    ],
                    template: [
                        {required: true, message: "请选择彩信模板"}
                    ],
                    rosterType: [
                        {required: true, message: "请选择名单类型"}
                    ],
                    planTime: [
                        {required: true, message: "请选择执行时间"}
                    ],
                    code: [
                        {required: true, min: 6, message: "请选择业务"}
                    ]
                },
                errors: {},
                headers: {
                    Authorization: this.$utils.getAuthToken(),
                },
                fileList: [],
                tip: "",
                templates: [],
                loading: null,
                groups: [],
                group: "",
              pickerOptions1: {
                disabledDate(time) {
                  return time.getTime() < Date.now() - 8.64e7;
                }
              }
            }
        },
        computed: {
            template() {
                return this.form.template;
            },
            accept() {
                if (this.form.type === 'mms_normal') {
                    return ".txt,.csv,.xlsx";
                } else {
                    return ".xlsx";
                }
            }
        },
        watch: {
            template(newVal) {
                let type = "";
                this.templates.forEach(template => {
                    if (template['value'] === newVal) {
                        type = template['type'];
                        return false;
                    }
                });

                if (type === "1") {
                    this.form.type = "mms_normal";
                } else if (type === "2") {
                    this.form.type = "mms_template";
                    this.form.rosterType = "file";
                }
            }
        },
        methods: {
            changeCode(code) {
                this.$axios.post("/group/list", {
                    rules: [
                        {field: "type", value: "mms"},
                        {field: "code", value: code},
                    ]
                }).then(data => {
                    this.groups = [{id:0, name: "默认"}].concat(data);
                    this.group = 0;
                    this.changeGroup(0);
                });
            },
            changeGroup(val) {
                this.$axios.post("/mms_template/list", {
                    orders: ['desc'],
                    sorts: ['createTime'],
                    rules: [
                        {"field": "groupId", "value": val},
                        {field: "code", value: this.form.code},
                    ]
                }).then((response) => {
                    let options = [];
                    response.forEach(v => {
                        options.push({"label": v.name, "value": v.id, "type": v['type']});
                    });
                    this.templates = options;
                })
            },
            submit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if (this.form.rosterType === "namelist" && !this.form.rosterContent) {
                            this.$message.error("请选择名单批次");
                            return;
                        }
                        if (this.form.rosterType === "textarea" && !this.form.rosterContent) {
                            this.$message.error("请选择填写手机号码");
                            return;
                        }
                        if (this.form.rosterType === "file") {
                            this.$refs.upload.submit();
                        } else {
                            this.$utils.post("/job/save", this.form, () => {
                                this.close();
                            }, (response) => {
                                this.$message({
                                    type: 'error',
                                    dangerouslyUseHTMLString: true,
                                    message: response.message
                                })
                            })
                        }
                    }
                });
            },
            close() {
                this.$router.go(-1);
            },
            onSuccess(response) {
                if (this.loading) {
                    this.loading.close();
                }
                this.$refs.upload.clearFiles();
                if (response.success) {
                    this.close();
                } else {
                    this.$message({
                        type: 'error',
                        dangerouslyUseHTMLString: true,
                        message: response.message
                    });
                }
            },
            beforeUpload() {
                this.loading = this.$loading({
                    lock: true,
                    text: '文件处理中，请稍候',
                });
            }
        }
    }
</script>